import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-conversation-sidebar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './conversation-sidebar.component.html',
  styleUrls: ['./conversation-sidebar.component.css'],
})
export class ConversationSidebarComponent implements OnInit {
  constructor(public state: AppStateService, private router: Router) { }

  ngOnInit(): void {
    this.state.initializeConversationState();
  }

  newConversation(): void {
    this.state.startNewConversation();
  }

  goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }

  selectConversation(threadId: string): void {
    this.state.loadConversation(threadId);
  }

  deleteConversation(threadId: string, evt: MouseEvent): void {
    evt.stopPropagation();
    this.state.deleteConversation(threadId);
  }

  clearHistory(): void {
    this.state.clearAllConversations();
  }

  getConversationTitle(): string {
    return this.state.currentConversationTitle();
  }

  getMessageCount(): number {
    return this.state.messages().length;
  }

  isActive(threadId: string): boolean {
    return this.state.activeThreadId() === threadId;
  }
}
